import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgTax2Icon = (props) => /* @__PURE__ */ _jsx("svg", {
	fill: "none",
	strokeLinecap: "round",
	strokeLinejoin: "round",
	strokeWidth: 1.5,
	stroke: "currentColor",
	viewBox: "0 0 16 16",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M7.60547 2.11243C7.84728 1.96276 8.1527 1.96282 8.39453 2.11243L13.6445 5.36243C13.9967 5.58044 14.1057 6.04247 13.8877 6.39465C13.6985 6.70027 13.3255 6.82262 13 6.70715V12.5001H13.25C13.6642 12.5001 14 12.8359 14 13.2501C13.9999 13.6643 13.6642 14.0001 13.25 14.0001H2.75C2.33582 14.0001 2.00006 13.6643 2 13.2501C2 12.8359 2.33579 12.5001 2.75 12.5001H3V6.70715C2.67455 6.82249 2.30146 6.70021 2.1123 6.39465C1.89439 6.04248 2.00332 5.58042 2.35547 5.36243L7.60547 2.11243ZM10 10.0001C9.30964 10.0001 8.75 10.5598 8.75 11.2501C8.75006 11.9404 9.30968 12.5001 10 12.5001C10.6903 12.5001 11.2499 11.9404 11.25 11.2501C11.25 10.5598 10.6904 10.0001 10 10.0001ZM10.498 6.43958C10.1885 6.1645 9.71461 6.19253 9.43945 6.50208L5.43945 11.0021C5.16444 11.3117 5.19243 11.7855 5.50195 12.0607C5.81152 12.3357 6.2854 12.3076 6.56055 11.9982L10.5605 7.49817C10.8356 7.1886 10.8075 6.71473 10.498 6.43958ZM6.25 6.00012C5.55964 6.00012 5 6.55977 5 7.25012C5.00006 7.94043 5.55968 8.50012 6.25 8.50012C6.94032 8.50012 7.49994 7.94043 7.5 7.25012C7.5 6.55977 6.94036 6.00012 6.25 6.00012Z",
		fill: "currentColor",
		stroke: "none"
	})
});
export default SvgTax2Icon;
